import axios from 'axios';

axios.interceptors.response.use((response) => {
  return response;
}, (err) => { // 这里是返回状态码不为200时候的错误处理
  if (err && err.response) {
    switch (err.response.status) {
      case 400:
        err.message = '请求错误'
        break
      case 401:
        err.message = '未授权，请登录'
        break
      case 403:
        err.message = '拒绝访问'
        break
      case 404:
        err.message = `请求地址出错: ${err.response.config.url}`
        break
      case 408:
        err.message = '请求超时'
        break
      case 500:
        console.log(err.response)
        err.message = err.response.data.message
        break
      case 501:
        err.message = '服务未实现'
        break
      case 502:
        err.message = '网关错误'
        break
      case 503:
        err.message = '服务不可用'
        break
      case 504:
        err.message = '网关超时'
        break
      case 505:
        err.message = 'HTTP版本不受支持'
        break
      default:
    }
  }
  return Promise.reject(err)
})

function apiUrl(url) {
  if (url.indexOf('/api') === 0 || url.indexOf('http') === 0) {
    return url
  }
  return '/api' + url
}

// 登录请求方法
const loginreq = (method, url, UserDCO) => {
  return axios({
    method: method,
    url: apiUrl(url),
    headers: {
      'Content-Type': 'application/json'
    },
    data: UserDCO,
    traditional: true,
  }).then(res => res);
};
// 通用公用方法
const getReq = (method, url, params) => {
  return axios({
    method: method,
    url: apiUrl(url),
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      token: localStorage.getItem('logintoken')
    },
    params: method.toLowerCase() === 'get' ? params : null,
    data: method.toLowerCase() !== 'get' ? params : null,
    traditional: false,
  }).then(res => res);
};
// 通用公用方法
const postRed = (method, url, params) => {
  return axios({
    method: method,
    url: apiUrl(url),
    headers: {
      'Content-Type': 'application/json',
      token: localStorage.getItem('logintoken')
    },
    data: params,
    traditional: true,
    // transformRequest: [
    //   function(data) {
    //     let ret = ''
    //     for (let it in data) {
    //       ret +=
    //         it+
    //         '=' +
    //         data[it]+
    //         '&'
    //     }
    //     console.log('ret-----',ret)
    //     return ret
    //   }
    // ]
  }).then(res => res);
};

export {
  loginreq,
  getReq,
  postRed
}



// WEBPACK FOOTER //
// ./src/api/axiosFun.js